import { render } from "./BulkUpload.vue?vue&type=template&id=2a4e6a0a&scoped=true"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"

import "./BulkUpload.vue?vue&type=style&index=0&id=2a4e6a0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4e6a0a"]])

export default __exports__